{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "सुप्रभात",
        "afternoon": "नमस्कार",
        "evening": "शुभ संध्या"
      },
      "header": {
        "fallbackUser": "उपयोगकर्ता",
        "facility": "सुविधा {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} गंभीर परिणाम की पुष्टि आवश्यक है",
        "message_other": "{{count}} गंभीर परिणामों की पुष्टि आवश्यक है",
        "reviewNow": "अभी समीक्षा करें"
      },
      "sections": {
        "overview": "अवलोकन",
        "tasks": "कार्य",
        "myPatients": "मेरे रोगी",
        "recentActivity": "हाल की गतिविधि",
        "quickActions": "त्वरित क्रियाएँ"
      },
      "stats": {
        "activeEncounters": "सक्रिय भेंट",
        "pendingOrders": "लंबित आदेश",
        "resultsToReview": "समीक्षा हेतु परिणाम",
        "criticalAlerts": "गंभीर चेतावनी"
      },
      "tasks": {
        "unsignedNotes": "अहस्ताक्षरित नोट्स",
        "criticalResultsPending": "लंबित गंभीर परिणाम",
        "cosignaturesNeeded": "सह-हस्ताक्षर आवश्यक",
        "ordersToReview": "समीक्षा हेतु आदेश",
        "activeMedications": "सक्रिय दवाएँ",
        "admissionsPending": "लंबित प्रवेश",
        "ordersToVerify": "फार्मासिस्ट सत्यापन हेतु आदेश",
        "controlledSubstanceReviews": "नियंत्रित औषधि समीक्षा",
        "systemAlerts": "सिस्टम चेतावनी",
        "systemStatus": "सिस्टम स्थिति"
      },
      "systemStatusValue": {
        "healthy": "सामान्य"
      },
      "empty": {
        "noPatients": "कोई सक्रिय रोगी असाइनमेंट नहीं।",
        "noTasks": "इस भूमिका हेतु कोई कार्य उपलब्ध नहीं।",
        "noRecentEncounters": "कोई हाल की भेंट नहीं।"
      },
      "quickActions": {
        "findPatient": {
          "label": "रोगी खोजें",
          "description": "रिकॉर्ड खोजें"
        },
        "registerPatient": {
          "label": "रोगी पंजीकरण",
          "description": "नया रोगी जोड़ें"
        },
        "viewCensus": {
          "label": "जनगणना देखें",
          "description": "सक्रिय भेंट"
        },
        "reports": {
          "label": "रिपोर्ट",
          "description": "विश्लेषण देखें"
        }
      },
      "viewAll": "सभी देखें",
      "bedLabel": "बेड {{n}}",
      "admittedLabel": "भर्ती {{date}}",
      "fallback": {
        "unknownPatient": "अज्ञात रोगी",
        "unknownType": "अज्ञात"
      },
      "acuity": {
        "1": "पुनरुज्जीवन",
        "2": "आपातकालीन",
        "3": "तत्काल",
        "4": "कम तत्काल",
        "5": "गैर-तत्काल"
      },
      "encounterType": {
        "emergency": "आपातकालीन",
        "inpatient": "अंतर्रोगी",
        "outpatient": "बहिर्रोगी",
        "observation": "अवलोकन"
      },
      "encounterStatus": {
        "active": "सक्रिय",
        "completed": "पूर्ण",
        "discharged": "डिस्चार्ज",
        "cancelled": "रद्द",
        "pending": "लंबित"
      }
    },
    "qualityMeasures": {
      "title": "गुणवत्ता संकेतक",
      "subtitle": "नैदानिक गुणवत्ता संकेतक और नियामक अनुपालन ट्रैक करें",
      "refresh": "रिफ़्रेश करें",
      "allTypesLabel": "सभी प्रकार",
      "allFacilitiesLabel": "सभी सुविधाएँ",
      "targetPrefix": "लक्ष्य: {{value}} {{unit}}",
      "updatedPrefix": "अपडेट: {{value}}",
      "measureType": {
        "process": "प्रक्रिया",
        "outcome": "परिणाम",
        "structure": "संरचनात्मक"
      },
      "summary": {
        "totalMeasures": "कुल संकेतक",
        "meetingTarget": "लक्ष्य पूर्ण",
        "belowTarget": "लक्ष्य से कम"
      },
      "toasts": {
        "refreshSuccess": "संकेतक रिफ़्रेश किए गए"
      },
      "results": {
        "title": "दर्ज परिणाम",
        "period": "अवधि",
        "facility": "सुविधा",
        "denominator": "हर",
        "numerator": "अंश",
        "exclusions": "अपवर्जन",
        "rate": "दर",
        "source": "स्रोत",
        "calculated": "परिकलित",
        "empty": "इस अवधि में इस माप के लिए कोई परिणाम दर्ज नहीं है।",
        "loadError": "दर्ज परिणाम लोड नहीं हो सके।",
        "allFacilities": "सभी सुविधाएँ",
        "record": "परिणाम दर्ज करें"
      },
      "sources": {
        "manual": "मैन्युअल",
        "sql-template": "SQL टेम्पलेट",
        "import": "आयात"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA रिपोर्ट डाउनलोड हो गई",
        "error": "QRDA डाउनलोड विफल"
      },
      "record": {
        "title": "गुणवत्ता परिणाम दर्ज करें",
        "titleFor": "परिणाम दर्ज करें — {{code}} {{name}}",
        "subtitle": "दर्ज परिणाम माप के इतिहास में दिखते हैं और QRDA श्रेणी III निर्यात में जाते हैं। किसी अवधि को दोबारा दर्ज करने पर पुरानी पंक्ति बदल जाती है।",
        "back": "गुणवत्ता मापों पर वापस जाएँ",
        "cancel": "रद्द करें",
        "save": "परिणाम दर्ज करें",
        "measureNotFound": "माप नहीं मिला। हो सकता है इसे निष्क्रिय कर दिया गया हो।",
        "fields": {
          "periodStart": "अवधि प्रारंभ",
          "periodEnd": "अवधि समाप्त",
          "facility": "सुविधा",
          "allFacilities": "सभी सुविधाएँ",
          "denominator": "हर",
          "numerator": "अंश",
          "exclusions": "अपवर्जन",
          "source": "गणना स्रोत",
          "completeness": "डेटा पूर्णता",
          "completenessHint": "पूर्ण डेटा वाले पात्र रिकॉर्ड का अंश, 0 से 1। अज्ञात हो तो खाली छोड़ें।",
          "notes": "टिप्पणियाँ"
        },
        "errors": {
          "periodStartRequired": "अवधि प्रारंभ आवश्यक है",
          "periodEndRequired": "अवधि समाप्त आवश्यक है",
          "periodOrder": "अवधि समाप्त, प्रारंभ के बाद या उसी दिन होना चाहिए",
          "countInvalid": "0 या अधिक पूर्ण संख्या दर्ज करें",
          "numeratorExceeds": "अंश हर से अधिक नहीं हो सकता",
          "numeratorExceedsNet": "अंश, हर में से अपवर्जन घटाने के बाद शेष से अधिक नहीं हो सकता",
          "sourceRequired": "गणना स्रोत आवश्यक है",
          "completenessRange": "पूर्णता 0 से 1 के बीच होनी चाहिए"
        },
        "toast": {
          "success": "परिणाम दर्ज हो गया",
          "error": "दर्ज करना विफल रहा"
        }
      }
    },
    "analyticsDashboard": {
      "title": "विश्लेषण डैशबोर्ड",
      "subtitle": "अस्पताल प्रदर्शन संकेतक और रुझान",
      "refresh": "रिफ़्रेश करें",
      "changeVsPrevPeriod": "पिछली अवधि की तुलना में {{sign}}{{value}}%",
      "dateRange": {
        "today": "आज",
        "7d": "7 दिन",
        "30d": "30 दिन",
        "90d": "90 दिन"
      },
      "facility": {
        "all": "सभी सुविधाएँ",
        "sgh": "SGH - सिंगापुर जनरल हॉस्पिटल",
        "nuh": "NUH - नेशनल यूनिवर्सिटी हॉस्पिटल",
        "ttsh": "TTSH - टैन टॉक सेंग हॉस्पिटल"
      },
      "department": {
        "all": "सभी विभाग",
        "er": "आपातकालीन",
        "icu": "आईसीयू",
        "medsurg": "मेड/सर्ज",
        "peds": "बाल चिकित्सा",
        "maternity": "प्रसूति"
      },
      "widget": {
        "census": {
          "title": "वर्तमान सेंसस"
        },
        "bedOccupancy": {
          "title": "बिस्तर अधिग्रहण"
        },
        "avgLOS": {
          "title": "औसत भर्ती अवधि"
        },
        "throughput": {
          "title": "कुल मुलाकातें"
        },
        "readmission": {
          "title": "लंबित ऑर्डर"
        }
      },
      "unit": {
        "patients": "रोगी",
        "days": "दिन",
        "encounters": "मुलाकातें",
        "orders": "ऑर्डर"
      },
      "charts": {
        "admissionsVsDischarges": "भर्ती बनाम छुट्टी",
        "admissionsByDepartment": "विभाग के अनुसार भर्ती",
        "encounterTypes": "मुलाकात प्रकार",
        "censusTrend": "सेंसस रुझान",
        "insufficientData": "चार्ट के लिए पर्याप्त डेटा नहीं",
        "insufficientTrendData": "रुझान चार्ट के लिए पर्याप्त डेटा नहीं"
      },
      "series": {
        "admissions": "भर्ती",
        "discharges": "छुट्टी",
        "census": "सेंसस"
      },
      "toasts": {
        "refreshSuccess": "डैशबोर्ड रिफ़्रेश किया गया"
      }
    },
    "reportRunner": {
      "title": "रिपोर्ट रनर",
      "subtitle": "क्लिनिकल, वित्तीय और परिचालन रिपोर्ट बनाएँ और एक्सपोर्ट करें",
      "scheduleButton": "रिपोर्ट शेड्यूल करें",
      "searchPlaceholder": "रिपोर्ट खोजें...",
      "allCategoriesLabel": "सभी रिपोर्ट",
      "category": {
        "clinical": "क्लिनिकल",
        "financial": "वित्तीय",
        "operational": "परिचालन",
        "quality": "गुणवत्ता"
      },
      "emptyState": {
        "title": "शुरू करने के लिए एक रिपोर्ट चुनें",
        "subtitle": "बाईं ओर की रिपोर्ट सूची में से चुनें"
      },
      "noResults": "आपके फ़िल्टर से मेल खाती कोई रिपोर्ट नहीं है",
      "parametersHeading": "पैरामीटर",
      "selectOptionPlaceholder": "चुनें...",
      "runButton": "रिपोर्ट चलाएँ",
      "runningReport": "रिपोर्ट चल रही है...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "तिथि (सुविधा स्थानीय समय)",
        "facilityTimeZone": "सुविधा का समय क्षेत्र",
        "encounterDate": "तिथि (UTC)"
      },
      "resultSummary": {
        "rows": "{{total}} में से {{shown}} पंक्तियाँ दिखाई जा रही हैं",
        "executed": "{{ms}}ms में निष्पादित"
      },
      "toasts": {
        "success": "रिपोर्ट {{executionTimeMs}}ms में पूर्ण - {{rowCount}} पंक्तियाँ",
        "failed": "रिपोर्ट चलाने में विफल",
        "missingFields": "कृपया आवश्यक फ़ील्ड भरें: {{missingFields}}",
        "exporting": "{{format}} के रूप में एक्सपोर्ट हो रहा है... (प्लेसहोल्डर)",
        "scheduledPlaceholder": "शेड्यूल की गई रिपोर्ट सेटअप (प्लेसहोल्डर)"
      }
    }
  }
}
